import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { normalizeMonthIds } from "../../assets/helpers";


const TELECALLER_DASHBOARD_API_URL = "/telecaller/stats/";
const TELECALLER_REPORT_API_URL = "telecaller/report-overview/";
const TELECALLER_BANK_DASHBOARD_API_URL = "telecaller/bank-dashboard/";
const TELECALLER_ACTION_CODES_API_URL = "telecaller/disposition-counts/";

export const fetchTelecallerDashboard = createAsyncThunk(
    "agency/fetchTelecallerDashboard",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            const query = state.filters.query;
            if (!token || !validUser.is_tc) {
                return;
            }

            const queryParams = { ...params };

            if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
                queryParams.portfolio = params.portfolios.join(',');
                delete queryParams.portfolios; // remove original array
            }
      if (Array.isArray(params?.months) && params?.months.length > 0) {
        queryParams.month = normalizeMonthIds(params.months);
        delete queryParams.months;
      }

            if (Array.isArray(params?.states) && params?.states.length > 0) {
                queryParams.state = params.states.join(',');
                delete queryParams.states; // remove original array
            }
            if (Array.isArray(params?.region) && params?.region.length > 0) {
                queryParams.region = params.region.join(',');
            }

            const response = await axios.get(TELECALLER_DASHBOARD_API_URL, {
                params: queryParams,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchTelecallerReport = createAsyncThunk(
    "agency/fetchTelecallerReport",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            const query = state.filters.query;
            if (!token || !validUser.is_tc) {
                return;
            }

            const queryParams = { ...params };

            if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
                queryParams.portfolio = params.portfolios.join(',');
                delete queryParams.portfolios; // remove original array
            }
      if (Array.isArray(params?.months) && params?.months.length > 0) {
        queryParams.month = normalizeMonthIds(params.months);
        delete queryParams.months;
      }

            if (Array.isArray(params?.states) && params?.states.length > 0) {
                queryParams.state = params.states.join(',');
                delete queryParams.states; // remove original array
            }
            if (Array.isArray(params?.region) && params?.region.length > 0) {
                queryParams.region = params.region.join(',');
            }

            const response = await axios.get(TELECALLER_REPORT_API_URL, {
                params: queryParams,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchTelecallerBankDashboard = createAsyncThunk(
    "portfolio/fetchTelecallerBankDashboard",
    async (_, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;

            const validUser = state.auth.user;
            if (!token || !validUser.is_tc) {
                return;
            }
            const response = await axios.get(TELECALLER_BANK_DASHBOARD_API_URL, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.portfolios;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch bank dashboard"
            );
        }
    }
);
export const fetchTelecallerActionCodes = createAsyncThunk(
    "portfolio/fetchTelecallerActionCodes",
    async (_, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;

            const validUser = state.auth.user;
            if (!token || !validUser.is_tc) {
                return;
            }
            const response = await axios.get(TELECALLER_ACTION_CODES_API_URL, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch bank dashboard"
            );
        }
    }
);


const initialState = {
    tele_dashboard: {},
    tele_dash_loading: false,

    tele_report_overview: {},
    tele_report_overview_loading: false,

    tele_bank_dashboard: [],
    tele_bank_dashboard_loading: false,

    tele_action_codes: {},
    tele_action_codes_loading: false,
};
const telecallerDashboard = createSlice({
    name: "telecallerDashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTelecallerDashboard.pending, (state) => {
                state.tele_dash_loading = true;

            })
            .addCase(fetchTelecallerDashboard.fulfilled, (state, action) => {
                state.tele_dash_loading = false;
                state.tele_dashboard = action.payload;
            })
            .addCase(fetchTelecallerDashboard.rejected, (state, action) => {
                state.tele_dash_loading = false;
                state.tele_dashboard = {};
            })


            .addCase(fetchTelecallerReport.pending, (state) => {
                state.tele_report_overview_loading = true;

            })
            .addCase(fetchTelecallerReport.fulfilled, (state, action) => {
                state.tele_report_overview_loading = false;
                state.tele_report_overview = action.payload;
            })
            .addCase(fetchTelecallerReport.rejected, (state, action) => {
                state.tele_report_overview_loading = false;
                state.tele_report_overview = {};
            })

            .addCase(fetchTelecallerBankDashboard.pending, (state) => {
                state.tele_bank_dashboard_loading = true;

            })
            .addCase(fetchTelecallerBankDashboard.fulfilled, (state, action) => {
                state.tele_bank_dashboard_loading = false;
                state.tele_bank_dashboard = action.payload;
            })
            .addCase(fetchTelecallerBankDashboard.rejected, (state, action) => {
                state.tele_bank_dashboard_loading = false;
                state.tele_bank_dashboard = [];
            })

            .addCase(fetchTelecallerActionCodes.pending, (state) => {
                state.tele_action_codes_loading = true;

            })
            .addCase(fetchTelecallerActionCodes.fulfilled, (state, action) => {
                state.tele_action_codes_loading = false;
                state.tele_action_codes = action.payload;
            })
            .addCase(fetchTelecallerActionCodes.rejected, (state, action) => {
                state.tele_action_codes_loading = false;
                state.tele_action_codes = {};
            })
    },
});

export default telecallerDashboard.reducer;
